import Api from "@/services/Api";

let controller = "investigator_sessions";

export default {
  index() {
    return Api().get(controller);
  },
  store(form) {
    return Api().post(controller, form);
  },
  view(investigatorId) {
    return Api().get(`${controller}/${investigatorId}`);
  },
  delete(investigatorId) {
    return Api().delete(`${controller}/${investigatorId}`);
  },
  restore(investigatorId) {
    return Api().put(`${controller}/${investigatorId}/restore`);
  },
  attachRandomCard(investigatorId, form) {
    return Api().post(`${controller}/${investigatorId}/attach_random_card`, form);
  },
  detachCard(investigatorId, cardBackId) {
    return Api().delete(`${controller}/${investigatorId}/detach_card/${cardBackId}`);
  },
  defeat(investigatorId) {
    return Api().delete(`${controller}/${investigatorId}/defeat`);
  },
  moveToInvestigatorAndDestroy(fromId, toId) {
    return Api().delete(`${controller}/${fromId}/move_cards_to_investigator_and_destroy/${toId}`);
  },
  moveAfter(investigatorSessionId, afterId) {
    return Api().put(`${controller}/${investigatorSessionId}/move_after`, {
      after_id: afterId
    });
  }
};
